var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "抽样单信息",
        okText: "关闭",
        cancelText: "取消",
        width: "700px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
        footer: null,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 8 },
                        wrapperCol: { span: 16 },
                        label: "受检单位名称",
                        prop: "name",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "name", $$v)
                          },
                          expression: "formState.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 8 },
                        wrapperCol: { span: 16 },
                        label: "抽样数量",
                        prop: "pickCount",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.pickCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "pickCount", $$v)
                          },
                          expression: "formState.pickCount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 8 },
                        wrapperCol: { span: 16 },
                        label: "抽样单上传",
                        prop: "pickFile",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { width: "90%" } },
                        [
                          _c("a-ext-upload", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.formState.pickFile,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "pickFile", $$v)
                              },
                              expression: "formState.pickFile",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }